<!-- 通知公告Notice -->
<template>
        <section class="notice bgL">
            <div class="container">
                <h3><i class="icons-sound"></i>最新公告：</h3>
                <ul class="new-list" :class="{anim:animate}" @mouseleave="up()" @mouseenter="stop()">
                    <li v-for="(notice, index) in noticeList" :key="index"><a href="#">{{notice.name}}</a></li>
                </ul>
                <div class="more">
                    <a class="btn minBtn hoverBg" href="#">更多公告</a>
                </div>
            </div>
        </section>
</template>
<script>
    export default {
        name: 'Notice',
        data() {
            return {
                noticeList: [{
                    name: '数据智能服务平台即将推出重大改版内容1'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容2'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容3'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容4'
                }, {
                    name: '数据智能服务平台即将推出重大改版内容5'
                }],
                animate: false,
                intNum: undefined,
            }
        },
        create() {
            this.scrollUp();
        },
        methods: {
            scrollUp() {
                this.intNum = setInterval(() => {
                    this.animate = true;// 向上滚动的时候需要添加css3过渡动画
                    setTimeout(() => {
                        this.noticeList.push(this.noticeList[0]);// 将数组的第一个元素添加到数组的
                        this.noticeList.shift(); //删除数组的第一个元素
                        this.animate = false;
                    }, 500)
                }, 3000);
            },
            //鼠标移上去停止
            stop() {
                clearInterval(this.intNum);
            },
            up() {
                this.scrollUp();
            },
        }
    }
</script>
<style scoped>
    .new-list {
        line-height: 50px;
        transition: top 0.5s;
    }

    .anim {
        transition: all 0.5s;
        margin-top: -50px;
    }
</style>